import React, { useEffect, useState } from 'react';
import { adminApi } from '../api';
import { Tag, FloppyDisk, CheckCircle, Warning, CircleNotch } from '@phosphor-icons/react';

export default function AdminBlackMonth() {
  const [cfg, setCfg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const [ok, setOk] = useState('');
  const [produtosStr, setProdutosStr] = useState('');

  const load = async () => {
    setLoading(true); setErr('');
    try {
      const d = await adminApi.blackMonthGet();
      setCfg(d);
      setProdutosStr((d.produtos || []).join(', '));
    } catch (e) { setErr(e.message || 'Erro ao carregar'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const set = (k, v) => setCfg((s) => ({ ...s, [k]: v }));

  const save = async () => {
    setErr(''); setOk(''); setSaving(true);
    try {
      const produtos = produtosStr.split(',').map((x) => parseInt(x.trim(), 10)).filter((n) => n > 0);
      const body = {
        ativa: !!cfg.ativa,
        inicio: cfg.inicio,
        fim: cfg.fim,
        produtos,
        por_grupo: Number(cfg.por_grupo),
        gratis: Number(cfg.gratis),
      };
      const d = await adminApi.blackMonthUpdate(body);
      setCfg(d);
      setProdutosStr((d.produtos || []).join(', '));
      setOk('Configuração guardada com sucesso.');
      setTimeout(() => setOk(''), 4000);
    } catch (e) { setErr(e.message || 'Erro ao guardar'); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="p-8 text-[#6B7280]" data-testid="black-month-loading">A carregar…</div>;
  if (!cfg) return <div className="p-8 text-[#DC2626]" data-testid="black-month-error">{err || 'Sem dados'}</div>;

  return (
    <div className="max-w-2xl mx-auto p-6" data-testid="admin-black-month-page" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-lg bg-[#0F1829] text-white grid place-items-center"><Tag size={20} /></div>
        <div>
          <h1 className="text-2xl font-black tracking-tighter text-[#0F1829]" style={{ fontFamily: "'Fraunces', serif" }}>Campanha Black Month</h1>
          <p className="text-sm text-[#6B7280]">Promoção de coaching «compra 4, paga 3» — período e produtos configuráveis.</p>
        </div>
      </div>

      <div className={`mt-4 mb-6 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-semibold ${cfg.ativa_agora ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' : 'bg-gray-100 text-gray-600 border border-gray-200'}`} data-testid="black-month-status">
        <CheckCircle size={16} weight={cfg.ativa_agora ? 'fill' : 'regular'} />
        {cfg.ativa_agora ? 'A campanha está ATIVA neste momento' : 'A campanha NÃO está ativa neste momento'}
      </div>

      <div className="bg-white rounded-xl border border-[#E5E7EB] p-6 shadow-sm space-y-5">
        <label className="flex items-center gap-3 cursor-pointer" data-testid="black-month-ativa">
          <input type="checkbox" className="w-5 h-5 accent-[#0F1829]" checked={!!cfg.ativa} onChange={(e) => set('ativa', e.target.checked)} />
          <span className="text-sm font-medium text-[#0F1829]">Campanha ativa (liga/desliga sem apagar as datas)</span>
        </label>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <label className="block text-sm text-[#6B7280]">Data de início
            <input type="date" data-testid="black-month-inicio" className="mt-1 w-full border border-[#E5E7EB] rounded-lg px-3 py-2 text-[#0F1829]" value={cfg.inicio || ''} onChange={(e) => set('inicio', e.target.value)} />
          </label>
          <label className="block text-sm text-[#6B7280]">Data de fim (inclusive)
            <input type="date" data-testid="black-month-fim" className="mt-1 w-full border border-[#E5E7EB] rounded-lg px-3 py-2 text-[#0F1829]" value={cfg.fim || ''} onChange={(e) => set('fim', e.target.value)} />
          </label>
        </div>

        <label className="block text-sm text-[#6B7280]">Produtos abrangidos (IDs separados por vírgula)
          <input type="text" data-testid="black-month-produtos" className="mt-1 w-full border border-[#E5E7EB] rounded-lg px-3 py-2 text-[#0F1829]" value={produtosStr} onChange={(e) => setProdutosStr(e.target.value)} placeholder="236, 936, 3475" />
        </label>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <label className="block text-sm text-[#6B7280]">Sessões por grupo
            <input type="number" min={2} data-testid="black-month-grupo" className="mt-1 w-full border border-[#E5E7EB] rounded-lg px-3 py-2 text-[#0F1829]" value={cfg.por_grupo} onChange={(e) => set('por_grupo', e.target.value)} />
          </label>
          <label className="block text-sm text-[#6B7280]">Sessões grátis por grupo
            <input type="number" min={1} data-testid="black-month-gratis" className="mt-1 w-full border border-[#E5E7EB] rounded-lg px-3 py-2 text-[#0F1829]" value={cfg.gratis} onChange={(e) => set('gratis', e.target.value)} />
          </label>
        </div>

        <p className="text-xs text-[#9CA3AF] bg-[#FAF8F2] rounded-lg p-3">
          Regra atual: por cada <strong>{cfg.por_grupo}</strong> sessões do mesmo produto, o cliente paga <strong>{Math.max(0, Number(cfg.por_grupo) - Number(cfg.gratis))}</strong> (oferta de {cfg.gratis}). Aplica-se na loja MY e nas encomendas do CRM.
        </p>

        {err && <div className="flex items-start gap-2 text-sm text-[#DC2626] bg-red-50 border border-red-200 rounded-lg p-3" data-testid="black-month-err"><Warning size={16} className="mt-0.5" />{err}</div>}
        {ok && <div className="flex items-start gap-2 text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg p-3" data-testid="black-month-ok"><CheckCircle size={16} className="mt-0.5" />{ok}</div>}

        <button onClick={save} disabled={saving} data-testid="black-month-save"
          className="w-full py-3 bg-[#0F1829] hover:bg-[#002480] text-white rounded-lg text-sm font-semibold flex items-center justify-center gap-2 transition-colors disabled:opacity-50">
          {saving ? <CircleNotch size={16} className="animate-spin" /> : <FloppyDisk size={16} />}
          Guardar configuração
        </button>
      </div>
    </div>
  );
}
